import React, { memo, useEffect } from "react";
import { useMutation, useNotify } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import { SchoolIdSelected } from "utils/tools";
import { Button } from "@material-ui/core";
import { calculationCostStudentWidgetValidation } from "utils/validation";

interface CalculationCostStudentButtonProps {
  setResultRegularCalculations: any;
  setResultCcaCalculations: any;
  setIsLoaded: (isLoaded: boolean) => void;
  formData: any;
}

const useStyles = makeStyles({
  root: {
    marginLeft: 0,
  },
});

const CalculationCostStudentButton = ({
  setResultRegularCalculations,
  setResultCcaCalculations,
  setIsLoaded,
  formData,
}: CalculationCostStudentButtonProps) => {
  const schoolId = Number(SchoolIdSelected());
  const notify = useNotify();
  const classes = useStyles();

  const isFixedLocationMonday =
    formData.isCcaMonday && formData.dropOffType === "fixed_location";
  const isFixedLocationTuesday =
    formData.isCcaTuesday && formData.dropOffType === "fixed_location";
  const isFixedLocationWednesday =
    formData.isCcaWednesday && formData.dropOffType === "fixed_location";
  const isFixedLocationThursday =
    formData.isCcaThursday && formData.dropOffType === "fixed_location";
  const isFixedLocationFriday =
    formData.isCcaFriday && formData.dropOffType === "fixed_location";

  let fixedLocationMondayId = formData.fixedLocationMondayId;
  let fixedLocationTuesdayId = formData.fixedLocationTuesdayId;
  let fixedLocationWednesdayId = formData.fixedLocationWednesdayId;
  let fixedLocationThursdayId = formData.fixedLocationThursdayId;
  let fixedLocationFridayId = formData.fixedLocationFridayId;
  if (formData.isUseOneFixedLocation === true) {
    fixedLocationMondayId = formData.fixedLocationId;
    fixedLocationTuesdayId = formData.fixedLocationId;
    fixedLocationWednesdayId = formData.fixedLocationId;
    fixedLocationThursdayId = formData.fixedLocationId;
    fixedLocationFridayId = formData.fixedLocationId;
  }

  useEffect(() => {
    setResultRegularCalculations(null);
    setResultCcaCalculations(null);
    setIsLoaded(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  const [HandleCalculationCost, { loading }] = useMutation(
    {
      type: "create",
      resource: "costPreview/registerStudent",
      payload: {
        data: {
          schoolId: schoolId,
          isRegisterRegularSchedule:
            formData.scheduleType === "regular" ||
            formData.scheduleType === "both",
          isRegisterCcaSchedule:
            formData.scheduleType === "cca" || formData.scheduleType === "both",
          regularStudentSchedule:
            formData.scheduleType === "regular" ||
              formData.scheduleType === "both"
              ? {
                academicYearId: formData.academicYearId,
                startedAt: formData.date,
                isTaking: true,
                detail: {
                  lat: formData.locationData?.LATITUDE,
                  lng: formData.locationData?.LONGITUDE,
                  street: formData.street,
                  unitNumber: formData.unitNumber
                    ? formData.unitNumber
                    : null,
                  blockNumber: formData.blockNumber,
                  postalCode: formData.postalCode,
                  building: formData.building,
                  isMonday: formData.isMonday ? true : false,
                  isTuesday: formData.isTuesday ? true : false,
                  isWednesday: formData.isWednesday ? true : false,
                  isThursday: formData.isThursday ? true : false,
                  isFriday: formData.isFriday ? true : false,
                  isFromSchool:
                    formData.wayType === "OneWayMorning" ? false : true,
                  isToSchool:
                    formData.wayType === "OneWayAfternoon" ? false : true,
                },
              }
              : null,
          ccaStudentSchedule:
            formData.scheduleType === "cca" || formData.scheduleType === "both"
              ? {
                ccaAcademicYearId: formData.ccaAcademicYearId,
                isTaking: true,
                dropOffType: formData.dropOffType,
                startedAt: formData.ccaDate,
                detail: {
                  isMonday: formData.isCcaMonday ? true : false,
                  fixedLocationMondayId: isFixedLocationMonday
                    ? fixedLocationMondayId
                    : null,
                  waveMondayId: isFixedLocationMonday
                    ? formData.waveMondayId
                    : null,
                  isTuesday: formData.isCcaTuesday ? true : false,
                  fixedLocationTuesdayId: isFixedLocationTuesday
                    ? fixedLocationTuesdayId
                    : null,
                  waveTuesdayId: isFixedLocationTuesday
                    ? formData.waveTuesdayId
                    : null,
                  isWednesday: formData.isCcaWednesday ? true : false,
                  fixedLocationWednesdayId: isFixedLocationWednesday
                    ? fixedLocationWednesdayId
                    : null,
                  waveWednesdayId: isFixedLocationWednesday
                    ? formData.waveWednesdayId
                    : null,
                  isThursday: formData.isCcaThursday ? true : false,
                  fixedLocationThursdayId: isFixedLocationThursday
                    ? fixedLocationThursdayId
                    : null,
                  waveThursdayId: isFixedLocationThursday
                    ? formData.waveThursdayId
                    : null,
                  isFriday: formData.isCcaFriday ? true : false,
                  fixedLocationFridayId: isFixedLocationFriday
                    ? fixedLocationFridayId
                    : null,
                  waveFridayId: isFixedLocationFriday
                    ? formData.waveFridayId
                    : null,
                  doorToDoorAddress:
                    formData.dropOffType === "door_to_door"
                      ? {
                        lat: formData.ccaLocationData?.LATITUDE,
                        lng: formData.ccaLocationData?.LONGITUDE,
                        street: formData.ccaStreet,
                        unitNumber: formData.ccaUnitNumber,
                        blockNumber: formData.ccaBlockNumber,
                        postalCode: formData.ccaPostalCode,
                        building: formData.ccaBuilding,
                      }
                      : null,
                  isFromCca:
                    formData.scheduleType === "cca" ||
                    formData.scheduleType === "both",
                },
              }
              : null,
        },
      },
    },
    {
      onSuccess: ({ res }) => {
        setResultRegularCalculations(res.json.updateRegularScheduleResponse);
        setResultCcaCalculations(res.json.updateCcaScheduleResponse);
        setIsLoaded(true);
      },
      onFailure: (error) => {
        notify(`Failed Calculation Cost, error: ${error.message}`, "warning");
        setResultRegularCalculations([]);
        setResultCcaCalculations([]);
      },
    }
  );

  return (
    <Button
      className={classes.root}
      variant="contained"
      color="primary"
      onClick={HandleCalculationCost}
      disabled={calculationCostStudentWidgetValidation(formData)}
    >
      {loading ? `Loading...` : `Calculation Cost`}
    </Button>
  );
};

export default memo(CalculationCostStudentButton);
